// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"21a19d6a","885":"9e38e84e"}[chunkId] + ".chunk.js";
};